import "@/index.css";

import { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";

import App from "@/App";
import { AuthProvider } from "@/contexts/auth-context";
import { queryClient } from "@/utils/query-client";

const environment = import.meta.env.VITE_NODE_ENV;

Sentry.init({
  dsn: "https://cf0cf91085352f01af10f9a35e0eeae3@o4508500609925120.ingest.de.sentry.io/4508500702265424",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  enabled: environment !== "development",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
